import { certifications } from "@/api/certification";
import { CalendarDate } from "@/components/Calendar";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { ProcessQueryEnabeld } from "./useProcessedQuery";

export const useCertificationQuery = (
  {
    predictionAccuracyEnabled,
    certificationEnabled,
    dailySourceEnabled,
    threeMonthPairSourceEnabled,
    statisticsEnabled,
    anomalyCountEnabled,
    peakReductionRateEnabled,
  }: ProcessQueryEnabeld,
  selectedDate?: CalendarDate,
  selectedMonth?: CalendarDate,
) => {
  const today = (selectedDate && selectedDate[0]) ?? new Date();
  const monthDate = (selectedMonth && selectedMonth[0]) ?? new Date();

  const { data: dailySource } = useQuery({
    ...certifications.getSource({
      type: "DAILY_SINGLE",
      date: dayjs(today).format("YYYY-MM-DD"),
    }),
    enabled: dailySourceEnabled,
  });

  const { data: threeMonthPairSource, isLoading: isLoadingThreeMonthPairSource } = useQuery({
    ...certifications.getSource({
      type: "THREE_MONTH_PAIR",
      date: dayjs(monthDate).format("YYYY-MM"),
    }),
    enabled: threeMonthPairSourceEnabled,
  });

  const { data: statisticsData, isLoading: isLoadingStatisticsData } = useQuery({
    ...certifications.getStatistics({
      type: "THREE_MONTH_PAIR",
      date: dayjs(monthDate).format("YYYY-MM"),
    }),
    enabled: statisticsEnabled,
  });

  const { data: anomalyCountData } = useQuery({
    ...certifications.getAnomalyCount({
      type: "YEARLY_SINGLE",
      date: dayjs(today).format("YYYY-MM-DD"),
    }),
    enabled: anomalyCountEnabled,
  });

  const { data: peakReductionRateData } = useQuery({
    ...certifications.peakReductionRate(),
    enabled: peakReductionRateEnabled,
  });

  return {
    dailySource,
    threeMonthPairSource,
    statisticsData,
    anomalyCountData,
    peakReductionRateData,
    isLoadingThreeMonthPairSource,
    isLoadingStatisticsData,
  };
};
